import axios from "axios";
import {
	ACCESS_TOKEN,
	CHANGE_CATEGORY_ACTIVE_STATUS_URL,
	CHANGE_VERIFICATION_STATUS_CATEGORY_URL,
	DELETE_CATEGORY_URL,
	GET_CATEGORY_BY_ID,
	GET_CATEGORY_LIST,
	GET_PARENT_CATEGORY_LIST,
	MAKE_HOT_CATEGORY_URL,
	POST_CATEGORY_URL,
	UPDATE_CATEGORY_URL,
} from "../helpers/Constant";

export default class CategoryService {
	static getCategoryList(params) {
		return axios.get(GET_CATEGORY_LIST, {
			...CategoryService.getAuthHeader(),
			params,
		});
	}

	static getCategoryById(id) {
		return axios.get(
			`${GET_CATEGORY_BY_ID}/${id}`,
			CategoryService.getAuthHeader(),
		);
	}

	static getParentCategoryList(params) {
		return axios.get(GET_PARENT_CATEGORY_LIST, {
			...CategoryService.getAuthHeader(),
			params,
		});
	}

	static addCategory(data) {
		return axios.post(
			POST_CATEGORY_URL,
			data,
			CategoryService.getAuthHeader(),
		);
	}

	static editCategory(id, data) {
		return axios.put(
			`${UPDATE_CATEGORY_URL}/${id}`,
			data,
			CategoryService.getAuthHeader(),
		);
	}

	static changeVerificationStatusCategory(id, approved) {
		return axios.put(
			`${CHANGE_VERIFICATION_STATUS_CATEGORY_URL}/${id}`,
			null,
			{
				...CategoryService.getAuthHeader(),
				params: { approved },
			},
		);
	}

	static deleteCategory(id) {
		return axios.delete(
			`${DELETE_CATEGORY_URL}/${id}`,
			CategoryService.getAuthHeader(),
		);
	}

	static makeHotCategory(id, hot) {
		return axios.put(`${MAKE_HOT_CATEGORY_URL}/${id}`, null, {
			...CategoryService.getAuthHeader(),
			params: { hot },
		});
	}

	static changeCategoryActiveStatus(id, active) {
		return axios.put(`${CHANGE_CATEGORY_ACTIVE_STATUS_URL}/${id}`, null, {
			...CategoryService.getAuthHeader(),
			params: { active },
		});
	}

	static getAuthHeader = () => {
		const accessToken = localStorage.getItem(ACCESS_TOKEN);
		return { headers: { "x-auth-token": `${accessToken}` } };
	};
}
